module.exports = __webpack_public_path__ + "static/img/mondoconnex-logo-icon@2x.45d8912.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mondoconnex-logo-icon@2x.png
// module id = 201
// module chunks = 14